module.exports = __webpack_public_path__ + "static/media/logoSmall.b0d9525f.png";